import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { CloudFunctionsApiService } from './cloud-functions-api.service';

@Injectable({
  providedIn: 'root',
})
export class EventosService {
  constructor(private api: CloudFunctionsApiService) {}

  getEventos() {
    return this.api.snapshotList('/events');
  }

  getEventosByUserid(uid) {
    return this.api.snapshotList(`/events?adminId=${encodeURIComponent(uid)}`);
  }

  getEventosByinvited(uid) {
    return this.api.snapshotList(`/events?studentId=${encodeURIComponent(uid)}`);
  }

  getEventosByUseridOrdenado(uid) {
    return this.getEventosByUserid(uid);
  }

  getConfirmadoAsistir(uid, eventuid) {
    if (!uid || !eventuid) {
      return of([]);
    }
    return this.api.snapshotList(`/events/${eventuid}/assisting-members/${uid}`);
  }

  getConfirmadoNoAsistir(uid, eventuid) {
    if (!uid || !eventuid) {
      return of([]);
    }
    return this.api.snapshotList(`/events/${eventuid}/non-assisting-members/${uid}`);
  }

  getEventoById(uid) {
    return this.api.documentChange(`/events/${uid}`);
  }

  createdEvento(evento) {
    return this.api.post('/events', evento).toPromise();
  }

  editEvento(uid, evento) {
    if (!uid) {
      return Promise.resolve(null);
    }
    return this.api.patch(`/events/${uid}`, evento).toPromise();
  }

  DeleteEvento(uid) {
    if (!uid) {
      return Promise.resolve(null);
    }
    return this.api.delete(`/events/${uid}`).toPromise();
  }

  DeleteMatchingEvento(evento) {
    return this.api.post('/events/delete-matching', evento).toPromise();
  }

  addAssistingMember(eventId, userId) {
    if (!eventId || !userId) {
      return Promise.resolve(null);
    }
    return this.api.post(`/events/${eventId}/assisting-members/${userId}`).toPromise();
  }

  removeAssistingMember(eventId, userId) {
    if (!eventId || !userId) {
      return Promise.resolve(null);
    }
    return this.api.delete(`/events/${eventId}/assisting-members/${userId}`).toPromise();
  }

  addNonAssistingMember(eventId, userId) {
    if (!eventId || !userId) {
      return Promise.resolve(null);
    }
    return this.api.post(`/events/${eventId}/non-assisting-members/${userId}`).toPromise();
  }

  removeNonAssistingMember(eventId, userId) {
    if (!eventId || !userId) {
      return Promise.resolve(null);
    }
    return this.api.delete(`/events/${eventId}/non-assisting-members/${userId}`).toPromise();
  }
}
